import { useRequiredPrepMillisecond } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionRequiredPrepMillisecond = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { requiredPrepMillisecond, requiredPrepMillisecondBeforeHour, requiredPrepMillisecondBeforeDate } = viewModel;

	return useRequiredPrepMillisecond({
		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
		onSet: onSetViewModel,
	});
};
